import SectionHeading from './SectionHeading';
import { themes, watchTips } from '@/mocks/themes';

export default function ThemesSection() {
  return (
    <section id="themes" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Themes"
          title="主题与看点：它到底想表达什么"
          desc="抛开猎奇标签，这部系列真正反复讨论的是成年人关系里的信任、倦怠与选择。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {themes.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-300 md:p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-700 md:text-sm">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg border border-background-200 bg-primary-950 p-6 md:p-8">
          <h3 className="font-heading text-lg font-semibold text-background-50 md:text-xl">观影前的三个小提示</h3>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {watchTips.map((item) => (
              <div key={item.step} className="rounded-md bg-background-50/10 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-accent-950">
                  <i className={`${item.icon}`}></i>
                </span>
                <p className="mt-3 font-heading text-sm font-semibold text-background-50">{item.step}</p>
                <p className="mt-1.5 text-xs leading-relaxed text-background-200">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}